import { render, staticRenderFns } from "./Beleg.vue?vue&type=template&id=1754db7b&"
import script from "./Beleg.vue?vue&type=script&lang=js&"
export * from "./Beleg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports